export const actionTypes = {
  allowedStatisticalCookies: '@store/Analytics/Allow',
}

export const actions = {
  allowedStatisticalCookies: () => ({ type: actionTypes.allowedStatisticalCookies }),
}
